import { useTranslation } from 'react-i18next';
import { Container } from "../../ui";
import styles from "./SolutionsHero.module.css";

export function SolutionsHero() {
  const { t } = useTranslation('solutions');

  return (
    <div className={styles.hero}>
      <Container>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('hero.title')}</h1>
          <p className={styles.subtitle}>{t('hero.subtitle')}</p>
        </div>
      </Container>
    </div>
  );
}
